export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-80 w-80 rounded-full bg-primary-200/40 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-12 md:px-6 lg:grid-cols-2 lg:gap-6 lg:pb-24 lg:pt-16">
        <div className="flex flex-col items-start gap-6">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-line"></i>
            安卓版 5.2.1 已上线
          </span>

          <h1 className="font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            吃瓜神器
            <span className="mt-1 block text-primary-500">最新版下载安装指南</span>
          </h1>

          <p className="max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            每天更新的娱乐热点聚合工具，把明星动态、综艺名场面、热搜话题一网打尽。
            这里汇总了吃瓜神器安卓手机版的稳定下载渠道、版本更新说明与常见安装问题，帮你快速装好、顺畅吃瓜。
          </p>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 shadow-none transition-all hover:-translate-y-0.5 hover:bg-primary-600"
            >
              <i className="ri-android-line text-lg"></i>
              立即下载安卓版
            </a>
            <a
              href="#version"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-base font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看版本更新
            </a>
          </div>

          <div className="mt-2 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-600"></i> 免费下载
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-600"></i> 无需付费解锁
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-600"></i> 低至安卓 6.0
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-600"></i> 包体约 46 MB
            </span>
          </div>
        </div>

        <PhoneMock />
      </div>
    </section>
  );
}

function PhoneMock() {
  return (
    <div className="relative mx-auto w-full max-w-sm lg:max-w-md">
      <div className="relative z-10 overflow-hidden rounded-[2.25rem] border-[10px] border-foreground-950 bg-background-50 shadow-2xl">
        <div className="absolute left-1/2 top-2 h-5 w-24 -translate-x-1/2 rounded-full bg-foreground-950"></div>

        <div className="flex h-[26rem] flex-col overflow-hidden bg-background-50 pt-7 md:h-[28rem]">
          <div className="px-4 pb-2">
            <p className="text-sm font-bold text-foreground-950">热门吃瓜 · 今日榜单</p>
            <p className="text-[11px] text-foreground-600">实时更新中</p>
          </div>

          <div className="flex flex-1 flex-col gap-3 overflow-hidden px-3 pb-4">
            <RankCard
              tag="热度"
              tagClass="bg-primary-500 text-background-50"
              title="最新一季音乐综艺首播收视出炉"
              meta="热议 12.8w · 5 分钟前"
            />
            <RankCard
              tag="焦点"
              tagClass="bg-accent-500 text-background-50"
              title="热播剧大结局剧情走向全梳理"
              meta="热议 8.6w · 18 分钟前"
            />
            <RankCard
              tag="动态"
              tagClass="bg-secondary-500 text-background-50"
              title="人气歌手新专辑上线各平台"
              meta="热议 6.2w · 42 分钟前"
            />
            <div className="flex items-center gap-2 rounded-xl border border-background-200 bg-background-100 p-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-flashlight-line"></i>
              </span>
              <div className="min-w-0">
                <p className="truncate text-xs font-semibold text-foreground-900">实时推送已开启</p>
                <p className="truncate text-[11px] text-foreground-600">瓜事不迟到，热点秒知道</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-around border-t border-background-200 bg-background-100/70 px-3 py-2 text-foreground-500">
            <i className="ri-fire-fill text-lg text-primary-500"></i>
            <i className="ri-global-line text-lg"></i>
            <i className="ri-star-line text-lg"></i>
            <i className="ri-user-3-line text-lg"></i>
          </div>
        </div>
      </div>

      <div className="absolute -right-4 top-16 z-20 flex items-center gap-2 rounded-xl border border-background-200 bg-background-50 px-3 py-2 shadow-xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
          <i className="ri-fire-line"></i>
        </span>
        <div>
          <p className="text-xs font-bold text-foreground-950">瓜值 +128</p>
          <p className="text-[10px] text-foreground-600">今日签到</p>
        </div>
      </div>
    </div>
  );
}

function RankCard({
  tag,
  tagClass,
  title,
  meta,
}: {
  tag: string;
  tagClass: string;
  title: string;
  meta: string;
}) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-3">
      <span className={`inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[10px] font-bold ${tagClass}`}>
        {tag}
      </span>
      <div className="min-w-0">
        <p className="truncate text-xs font-semibold leading-snug text-foreground-900">{title}</p>
        <p className="mt-1 truncate text-[11px] text-foreground-600">{meta}</p>
      </div>
    </div>
  );
}